// Mask all except the last 3 characters with 'X'
export const maskBankInfo = (number) => {
  const maskedPart = number.slice(0, -3).replace(/\d/g, 'X');
  const lastThree = number.slice(-3);
  return maskedPart + lastThree;
};
